import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {TranslationServiceInterface} from 'quote-export-manager-core';


@Injectable({
    providedIn: 'root',
})
export class TranslationProviderService implements TranslationServiceInterface {

    constructor(private translateService: TranslateService) {
    }

    translate(key: string, lang: string): Promise<string> {
        return Promise.resolve(this.translateService.instant(key));
    }

}
